import { createContext, useContext, useState, useEffect, ReactNode, useCallback } from "react";

interface GamificationContextType {
  visitedPages: Set<string>;
  visitPage: (page: string) => void;
  triggerEasterEgg: (eggId: string) => void;
}

const GamificationContext = createContext<GamificationContextType | undefined>(undefined);

export function GamificationProvider({ children }: { children: ReactNode }) {
  const [visitedPages, setVisitedPages] = useState<Set<string>>(() => {
    const saved = localStorage.getItem("engagexp-visited-pages");
    return saved ? new Set(JSON.parse(saved)) : new Set();
  });

  useEffect(() => {
    localStorage.setItem("engagexp-visited-pages", JSON.stringify([...visitedPages]));
  }, [visitedPages]);

  const visitPage = useCallback((page: string) => {
    setVisitedPages(prev => {
      if (prev.has(page)) return prev;
      return new Set([...prev, page]);
    });
  }, []);

  const triggerEasterEgg = useCallback((_eggId: string) => {
    // Easter egg triggered — silent in production
  }, []);

  return (
    <GamificationContext.Provider
      value={{
        visitedPages,
        visitPage,
        triggerEasterEgg
      }}
    >
      {children}
    </GamificationContext.Provider>
  );
}

export function useGamification() {
  const context = useContext(GamificationContext);
  if (!context) {
    throw new Error("useGamification must be used within GamificationProvider");
  }
  return context;
}